import axiosService from '../axios.service';

const accountDataService = {

  get(params) {
    return new Promise((resolve) => {
      let querystring = ""
     
      if (params.userId) {
        querystring += `&userId=${params.userId}`
      }

      if (params.phoneNumber) {
        querystring += `&phoneNumber=${params.phoneNumber}`
      }

      axiosService.api.get(`/account?${querystring}`)
        .then(response => { 
          resolve(response.data);
        })
    })
  },
  
  add(account) {
    return new Promise((resolve) => {

      axiosService.api.post(`/account`, account)
        .then(response => {
          resolve(response);
        })
    })
  },

  update(account) {
    return new Promise((resolve) => {
      axiosService.api.put(`/account`, account)
        .then(response => {
          resolve(account);
        })
        .catch(e => {
          console.log(e);
        })
    })
  },
}

export default accountDataService